'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _BaseExperimentEvaluator = require('./BaseExperimentEvaluator');
var _BaseExperimentEvaluator2 = _interopRequireDefault(_BaseExperimentEvaluator);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * Evaluator used before global shared variable is initialized with {@link ExperimentEvaluator}
 * This is needed to keep experiments from evaluating and logging when client-side components
 * are rendered on server-side
 *
 * Once a `window.__TNL__` is defined, this implementation of {@link BaseExperimentEvaluator} won't be used.h
 *
 * @implements {BaseExperimentEvaluator}
 */
var NoopExperimentEvaluator = function (_BaseExperimentEvalua) {
  _inherits(NoopExperimentEvaluator, _BaseExperimentEvalua);
  function NoopExperimentEvaluator() {
    _classCallCheck(this, NoopExperimentEvaluator);
    return _possibleConstructorReturn(this, (NoopExperimentEvaluator.__proto__ || Object.getPrototypeOf(NoopExperimentEvaluator)).apply(this, arguments));
  }
  _createClass(NoopExperimentEvaluator, [{
    key: 'evaluateExperiment',
    /**
     * No-op implementation; parameters are ignored
     *
     * @param {number} experimentId - the id of the experiment to evaluate
     * @returns {EvaluationData}
     */
    // eslint-disable-next-line no-unused-vars
    value: function evaluateExperiment(experimentId) {}
    // do nothing

    /**
     * No-op implementation; parameters are ignored
     *
     * @returns {EvaluationData}
     */
  }, {
    key: 'evaluateAllExperiments',
    value: function evaluateAllExperiments() {}
    // do nothing

    /**
     * No-op implementation; parameters are ignored
     *
     * @param {number} experimentId - the id of the experiment to evaluate
     * @param {object} [edapTriggerOptions] - The `triggerOptions` object that is applied to the EDAP `test.exposure` event. See {@link https://github.homeawaycorp.com/edap/edap-integrations/blob/master/API.md#triggereventname-data-opts|triggerOptions}.
     * @param {object} [edapData] - Contains any additional properties to include in the edap event
     * @returns {EvaluationData}
     */
    // eslint-disable-next-line no-unused-vars
  }, {
    key: 'evaluateExperimentAndLog',
    value: function evaluateExperimentAndLog(experimentId, edapTriggerOptions, edapData) {}
    // do nothing

    /**
     * No-op implementation; parameters are ignored
     *
     * Please ensure you understand how to separate evaluation from logging before using this method. Your experiment will
     * be invalid if the passed in EvaluationData has not come as a result of calling evaluateExperiment().
     *
     * @param {EvaluationData|number} evaluationData - Object that contains information about the evaluated test. Alternatively, supply an experiment id.
     * @param {object} [edapTriggerOptions] - The `triggerOptions` object that is applied to the EDAP `test.exposure` event. See {@link https://github.homeawaycorp.com/edap/edap-integrations/blob/master/API.md#triggereventname-data-opts|triggerOptions}.
     * @param {object} [edapData] - Contains any additional properties to include in the edap event
     */
    // eslint-disable-next-line no-unused-vars
  }, {
    key: 'logExperiment',
    value: function logExperiment(evaluationData, edapTriggerOptions, edapData) {
      // do nothing
    }
  }]);
  return NoopExperimentEvaluator;
}(_BaseExperimentEvaluator2.default);
exports.default = NoopExperimentEvaluator;